import { Component, inject } from '@angular/core';

import { ModalService } from '../../services/modal.service';

@Component({
  selector: 'app-modal',
  standalone: true,
  imports: [],
  template: `
    @if (modalService.currentModal(); as modal) {
      <div class="fixed inset-0 z-[200] flex items-center justify-center p-4 bg-dark-900/80 backdrop-blur-sm animate-fade-in">
        <div class="bg-dark-800 border border-white/10 p-8 rounded-3xl shadow-2xl max-w-md w-full animate-scale-up relative overflow-hidden">
          <div class="absolute top-0 right-0 w-32 h-32 bg-primary-500/10 rounded-full blur-3xl -mr-10 -mt-10 pointer-events-none"></div>
          <h3 class="text-2xl font-bold text-white mb-4 relative z-10">{{ modal.title }}</h3>
          <p class="text-gray-300 mb-8 leading-relaxed font-medium relative z-10">{{ modal.message }}</p>
          <div class="flex gap-4 justify-end relative z-10">
            <button (click)="modalService.close(false)" class="px-6 py-3 rounded-xl font-bold text-gray-400 hover:text-white bg-dark-900 hover:bg-dark-700 border border-white/10 transition-colors">
              {{ modal.cancelText || 'Cancel' }}
            </button>
            <button (click)="modalService.close(true)" class="px-6 py-3 rounded-xl font-bold text-white bg-primary-600 hover:bg-primary-500 shadow-[0_0_15px_rgba(145,70,255,0.3)] transition-all">
              {{ modal.confirmText || 'Confirm' }}
            </button>
          </div>
        </div>
      </div>
    }
    `,
  styles: [`
    @keyframes fadeIn {
      from { opacity: 0; }
      to { opacity: 1; }
    }
    .animate-fade-in {
      animation: fadeIn 0.15s ease-out forwards;
    }
    @keyframes scaleUp {
      from { transform: scale(0.95); opacity: 0; }
      to { transform: scale(1); opacity: 1; }
    }
    .animate-scale-up {
      animation: scaleUp 0.15s ease-out forwards;
    }
  `]
})
export class ModalComponent {
  modalService = inject(ModalService);
}
